import React, {useEffect, useRef, useState} from "react";
import icon1 from "../../assets/images/setting-icon.svg";
import LoadingPage from "../../components/LoadingPage";
import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import newsletterPlugin from "grapesjs-preset-newsletter";
import {toast} from "react-toastify";
import {addDoctorTemplateApi, checkAdminTokenApi, getDoctorTemplateApi, uploadTemplateAssetApi} from "../../services/apiService";
import {useNavigate, useParams} from "react-router";
import {ADMIN_DASHBOARD_URL} from "../../app_url";
import html2canvas from "html2canvas";

const AdminPrescriptionManagement = () => {
  const {token} = useParams();
  const navigate = useNavigate();
  const editorContainer = useRef(null);
  const editorContentRef = useRef("");
  const [screenLoading, setScreenLoading] = useState(false);
  const [screenLoading1, setScreenLoading1] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [cssContent, setCssContent] = useState("");
  const [btnDis, setBtnDis] = useState(false);
  const [templateName, setTemplateName] = useState();
  const [isEditorVisible, setIsEditorVisible] = useState(true);
  const [editorInstanceState, setEditorInstanceState] = useState();
  const [category, setCategory] = useState();

  useEffect(() => {
    if (editorInstanceState && typeof editorInstanceState.getWrapper === 'function' && category) {
      const wrapper = editorInstanceState.getWrapper();
      if (!wrapper) return;
      const allComponents = wrapper.find("*");

      // Search for components containing "PRESCRIPTION" or "ORDONNANCE"
      let componentsToUpdate = allComponents.filter((c) => {
        const content = c.get("content") || "";
        return (
          c.getAttributes().id === "template-title" ||
          /PRESCRIPTION|ORDONNANCE/i.test(content)
        );
      });

      if (category === "1") {
        // "Ordonnance" selected — do not insert a title, ensure any existing title is removed
        if (componentsToUpdate.length > 0) {
          componentsToUpdate.forEach((titleComp) => {
            try {
              titleComp.remove();
            } catch (e) {}
          });
        }
      } else if (category === "2") {
        // "Document" selected
        componentsToUpdate.forEach((titleComp) => {
          titleComp.remove();
        });
      }
    }
  }, [category, editorInstanceState]);

  useEffect(() => {
    let isCancelled = false;
    let editorInstance;
    if (isEditorVisible && editorContainer.current) {
      editorInstance = grapesjs.init({
        container: editorContainer.current,
        fromElement: false,
        storageManager: false, // Disable storage
        blockManager: {
          appendTo: "#blocks", // Container where blocks will be appended
        },
        canvas: {
          styles: [
            "https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap",
          ],
        },
        plugins: [newsletterPlugin],
        pluginsOpts: {
          'gjs-preset-newsletter': {
            // Disable default newsletter content
            blocksBasicOpts: {
              /* Disable default blocks if needed */
            },
            // Prevent adding default template
          }
        },
        assetManager: {
          upload: true,
          uploadName: 'files',
          async uploadFile(e) {
            const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
              formData.append('files[]', files[i]);
            }
            try {
              const response = await uploadTemplateAssetApi(formData);
              if (response.data && response.data.res) {
                if (!isCancelled && editorInstance && editorInstance.AssetManager) {
                  editorInstance.AssetManager.add(response.data.data);
                }
              } else {
                toast.error(response.data.msg || "Upload failed");
              }
            } catch (error) {
              console.error("Asset upload error:", error);
              toast.error("Error uploading image");
            }
          },
        },
        avoidInlineStyle: 1,
        forceClass: false,
        panels: false,
      });

      // Add A4 page styling to the canvas
       editorInstance.on("load", () => {
         if (isCancelled) return;
         const doc = editorInstance.Canvas.getDocument();
         if (!doc) return;
         const style = doc.createElement("style");
         style.innerHTML = `
           html {
             background-color: #50596c !important;
           }
           body {
             background-color: #50596c !important;
             display: flex !important;
             justify-content: center !important;
             padding: 40px 0 !important;
             margin: 0 !important;
             height: auto !important;
             min-height: 100vh !important;
           }
           /* Target GrapesJS wrapper specifically */
           .gjs-wrapper, #wrapper, [data-gjs-type="wrapper"] {
             width: 210mm !important;
             min-height: 297mm !important;
             height: auto !important;
             background-color: white !important;
             box-shadow: 0 0 30px rgba(0,0,0,0.5) !important;
             margin: 0 auto !important;
             overflow: visible !important;
             position: relative !important;
             box-sizing: border-box !important;
             display: block !important;
           }
           /* Ensure all direct children of the wrapper fit the A4 width */
           .gjs-wrapper > *, #wrapper > * {
             max-width: 100% !important;
           }
           /* Ensure the dashed outline follows the content height */
           .gjs-dashed *[data-gjs-type="wrapper"], .gjs-dashed .gjs-wrapper {
             width: 210mm !important;
             min-height: 297mm !important;
             height: auto !important;
           }

           /* Prevent empty elements from collapsing in the editor */
           div:empty, section:empty, td:empty {
             min-height: 14px;
           }
         `;
         if (doc.head) {
           doc.head.appendChild(style);
         }
       });

      editorInstance.BlockManager.add("custom-text-block", {
        label: "Texte", // Label for the block that appears in the block panel
        content: `
          <div class="custom-text-block" style="font-size: 14px; margin: 0;">
            <span>Entrez votre texte ici...</span>
          </div>
        `,
        // category: "Basic", // Category under which the block will be listed in the panel
        attributes: {
          title: "Faites glisser pour ajouter un bloc de texte personnalisé",
        }, // Tooltip for the block
      });

      // Custom Patient Card component type
      editorInstance.DomComponents.addType("patient-card", {
        model: {
          defaults: {
            tagName: "div",
            attributes: { class: "patient-card" },
            components: [
              { type: "text", content: "[patient-name-age-gender]", classes: ["patient-info"] },
              { type: "text", content: "[patient-address-block]", classes: ["patient-address"] },
            ],
            styles: `
              .patient-card { margin-bottom: 10px; }
              .patient-info { font-size: 14px; display:block; margin: 0; padding: 0; }
              .patient-address { font-size: 14px; display:block; margin: 0; padding: 0; }
            `,
          },
        },
      });

      // Custom Doctor Card component type
      editorInstance.DomComponents.addType("doctor-card", {
        model: {
          defaults: {
            tagName: "div",
            attributes: { class: "doctor-card" },
            components: [
              { type: "text", content: "[docteur-name]", classes: ["doc-name"] },
              { type: "text", content: "[docteur-speciality]", classes: ["doc-speciality"] },
              { type: "text", content: "[docteur-reg-number]", classes: ["doc-reg"] },
              { type: "text", content: "[docteur-clinic-name]", classes: ["doc-clinic"] },
              { type: "text", content: "[docteur-address-one]", classes: ["doc-addr1"] },
              { type: "text", content: "[docteur-address-two]", classes: ["doc-addr2"] },
              { type: "text", content: "[docteur-phone]", classes: ["doc-phone"] },
              { type: "text", content: "[docteur-email]", classes: ["doc-email"] },
            ],
            styles: `
              .doctor-card { padding: 10px; border: none; }
              .doc-name { font-size: 20px; font-weight: bold; display:block; margin: 0; }
              .doc-speciality { font-size: 16px; color: #555; display:block; margin: 0; }
              .doc-reg { font-size: 14px; display:block; margin: 0; }
              .doc-clinic { font-size: 14px; display:block; margin: 0; }
              .doc-addr1 { font-size: 14px; display:block; margin: 0; }
              .doc-addr2 { font-size: 14px; display:block; margin: 0; }
              .doc-phone { font-size: 14px; display:block; margin: 0; }
              .doc-email { font-size: 14px; display:block; margin: 0; }
            `,
          },
        },
      });

      editorInstance.BlockManager.add("custom-Medication-block", {
        label: "Médicaments",
        content: `
          <div class="medication-section" style="font-size: 14px; margin: 0; padding: 0; page-break-inside: auto; page-break-before: auto;">
            <div style="margin: 0; padding: 0; page-break-inside: auto;">[Médicaments]</div>
          </div> `,
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-Doctor-Name-block", {
        label: "Nom du docteur",
        content: `<span>[docteur-name]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Info-Block", {
        label: "Doctor Info Block",
        content: { type: "doctor-card" },
      });

      editorInstance.BlockManager.add("custom-Doctor-Speciality-block", {
        label: "Spécialité du docteur",
        content: `<span>[docteur-speciality]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Reg-block", {
        label: "Matricule du docteur",
        content: `<span>[docteur-reg-number]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Clinic-block", {
        label: "Nom de la clinique",
        content: `<span>[docteur-clinic-name]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Address-One-block", {
        label: "Adresse 1 du docteur",
        content: `<span>[docteur-address-one]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Address-Two-block", {
        label: "Adresse 2 du docteur",
        content: `<span>[docteur-address-two]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Phone-block", {
        label: "Téléphone du docteur",
        content: `<span>[docteur-phone]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Email-block", {
        label: "Email du docteur",
        content: `<span>[docteur-email]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Details-block", {
        label: "Détails du médecin",
        content: `
          <div class="text-section" style="font-size: 14px; margin: 0; padding: 0; height: auto;">
            <div style="margin: 0; padding: 0;">[Détails du médecin]</div>
          </div> `,
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-Patient-Details-block", {
        label: "Détails du patient",
        content: { type: "patient-card" },
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-Date-block", {
        label: "Date",
        content: `<span style="font-size: 14px; margin: 0; display: inline-block;">Date: [date]</span>`,
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-qr-code-block", {
        label: "Code QR",
        content: `
          <div class="qr-code-container" style="display: inline-block; width: 80px; height: 80px; border: 1px dashed #ccc; background-color: #f9f9f9; text-align: center; padding: 0; margin: 0; overflow: hidden;">
            <div style="font-size: 10px; color: #999; line-height: 80px; margin: 0; padding: 0;">[code qr]</div>
          </div>
        `,
      });

      // editorInstance.BlockManager.add("custom-text-block", {
      //   label: "Custom text section",
      //   content: `
      //     <div class="text-section" style="font-size: 18px;">
      //       <p>Text section</p>
      //     </div> `,
      //   category: "Basic",
      // });

      editorInstance.BlockManager.getAll().remove("link");
      editorInstance.BlockManager.getAll().remove("link-block");
      editorInstance.BlockManager.getAll().remove("text");
      // editorInstance.BlockManager.getAll().remove('sect100');
      // editorInstance.BlockManager.getAll().remove('sect50');
      // editorInstance.BlockManager.getAll().remove('sect30');
      // editorInstance.BlockManager.getAll().remove('sect37');
      editorInstance.BlockManager.getAll().remove("text-sect");
      editorInstance.BlockManager.getAll().remove("quote");
      editorInstance.BlockManager.getAll().remove("button");
      editorInstance.BlockManager.getAll().remove("link");
      editorInstance.BlockManager.getAll().remove("link-block");
      editorInstance.BlockManager.getAll().remove("list-items");
      editorInstance.BlockManager.getAll().remove("grid-items");

      // Clear any default content added by the plugin
      editorInstance.on("load", () => {
        const wrapper = editorInstance.getWrapper();
        if (wrapper) {
          wrapper.components([]);
        }
      });

      // Fetch the data from the server (you can use axios, fetch, etc.)
      const fetchData = async () => {
        try {
          if (!isCancelled) setScreenLoading1(true);
          let formData = new FormData();
          formData.append("id", '1');

          let response = await getDoctorTemplateApi(formData);
          if (isCancelled) return;

          if (response && editorInstance && typeof editorInstance.setComponents === 'function') {
            if (response.data.res === true && response.data.data) {

              function applyBackgroundImageToWrapper(styleString, bodyId) {
                const bodyIdSelector = `#${bodyId}`;
                const backgroundImageRegex = /background(?:-image)?:\s*url\(['"]?([^'"\)]+)['"]?\)/i;

                if (!styleString || typeof styleString !== 'string') return styleString;

                let updatedStyle = styleString;
                
                // In the editor, we want to target the wrapper, not the body.
                if (bodyId && styleString.includes(bodyIdSelector)) {
                  updatedStyle = styleString.replace(new RegExp(bodyIdSelector.replace(/[#.:]/g, '\\$&'), 'g'), '[data-gjs-type="wrapper"]');
                } else {
                  updatedStyle = updatedStyle.replace(/body\s*{/gi, '[data-gjs-type="wrapper"] {');
                }

                const match = updatedStyle.match(backgroundImageRegex);
                if (match) {
                  const backgroundImageUrl = match[1];
                  updatedStyle = updatedStyle.replace(backgroundImageRegex, `background-image:url('${backgroundImageUrl}')`);
                  updatedStyle = updatedStyle.replace(/\[data-gjs-type="wrapper"\]\s*{([^}]*)}/i, (m, decls) => {
                    let newDecls = decls;
                    if (!/background-size\s*:/i.test(decls)) newDecls += ' background-size: auto;';
                    if (!/background-position\s*:/i.test(decls)) newDecls += ' background-position: center top;';
                    if (!/background-repeat\s*:/i.test(decls)) newDecls += ' background-repeat: no-repeat;';
                    return `[data-gjs-type="wrapper"] {${newDecls} }`;
                  });
                  return updatedStyle;
                }

                return updatedStyle;
              }

              function loadTemplateFromHtmlCss(editorInstance, templateBody, templateStyle, applyBackgroundImageToWrapper) {
                if (typeof editorInstance.setComponents === 'function') {
                  editorInstance.setComponents(templateBody);
                  
                  if (templateStyle) {
                    const canvasDoc = editorInstance.Canvas.getDocument();
                    const styleEl = canvasDoc.createElement('style');
                    styleEl.id = 'prescription-template-style';
                    styleEl.textContent = templateStyle;
                    const existingStyle = canvasDoc.getElementById('prescription-template-style');
                    if (existingStyle) {
                      existingStyle.remove();
                    }
                    canvasDoc.head.appendChild(styleEl);
                    
                    editorInstance.setStyle(templateStyle);
                  }
                  
                  let updatedStyle = templateStyle;
                  if (templateBody && templateStyle) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(templateBody, "text/html");
                    const wrapperElement = doc.body.firstElementChild;
                    const bodyId = wrapperElement ? wrapperElement.id : null;
                    updatedStyle = applyBackgroundImageToWrapper(templateStyle, bodyId);
                  }

                  if (templateStyle) {
                    const backgroundImageRegex = /background(?:-image)?:\s*url\(['"]?([^'"\)]+)['"]?\)/i;
                    const match = templateStyle.match(backgroundImageRegex);
                    if (match) {
                      const backgroundImageUrl = match[1];
                      const wrapper = editorInstance.getWrapper();
                      if (wrapper) {
                        wrapper.addStyle({
                          "background-image": `url('${backgroundImageUrl}')`,
                          "background-size": "auto",
                          "background-position": "center top",
                          "background-repeat": "no-repeat",
                        });
                      }
                    }
                  }
                }
              }

              if (editorInstance && typeof editorInstance.setComponents === 'function') {
                const projectData = response.data.data.project_data;
                
                if (projectData) {
                  try {
                    const parsedProjectData = typeof projectData === 'string' 
                      ? JSON.parse(projectData) 
                      : projectData;
                    editorInstance.loadProjectData(parsedProjectData);
                  } catch (error) {
                    console.error("Failed to load project data, falling back to HTML/CSS:", error);
                    loadTemplateFromHtmlCss(editorInstance, response.data.data.template_body, response.data.data.style, applyBackgroundImageToWrapper);
                  }
                } else {
                  loadTemplateFromHtmlCss(editorInstance, response.data.data.template_body, response.data.data.style, applyBackgroundImageToWrapper);
                }
              }

              if (!isCancelled) {
                setTemplateName(response.data.data.template_name);
                setCategory(response.data.data.category ? response.data.data.category.toString() : "");
              }
            } else {
              if (response.data.msg && !isCancelled) {
                toast.error(response.data.msg, {autoClose: 1500});
              }
            }
          }
        } catch (error) {
          console.error(error);
          // Only show toast if component is still mounted (best effort check)
          if (!isCancelled && editorContainer.current) {
            toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
          }
        } finally {
          if (!isCancelled) setScreenLoading1(false);
        }
      };

      // Call fetchData to load the components on mount
      fetchData();

      // editorInstance.setComponents(
      //   `<body id="ikaz"><table id="iw0e"><tbody><tr><td id="i2pv2"><div class="custom-text-block" id="i8lzn"><span id="ika0j">Dr. John Smith, MD<br/>Dentist<br/>Reg No. 98562<br/><br/>Sunrise Medical Clinic<br/></span></div><div class="custom-text-block" id="i2onl"></div><div class="custom-text-block" id="ii8n3"><span id="i4nxw">123 lane,  suite 156<br/>Cityville, State, Zip code<br/><br/></span><div class="custom-text-block" id="i6uhf"><span id="irkol"><b>Phone</b>: </span><span id="islrl">(123) 456-789</span></div><div class="custom-text-block" id="i9qol"><span id="i5iwu"><b id="ir3lt">Email</b>: </span><span id="iyrps">dr.johnsmith@sunrisemedical.com</span></div></div></td><td id="igc4j"></td><td id="i6gbh"></td></tr></tbody></table><div class="custom-text-block" id="iy9q8"></div><div class="custom-text-block" id="iza8s"></div><table id="i778m"><tbody><tr><td class="divider"></td></tr></tbody></table><table id="iumgo"><tbody><tr><td id="ifrz5"><div id="ivyo7">Mr, BILEL CHENCHANA, 30/02/2000 (24 years)</div></td><td id="ibfpj"><div id="i4mle"><font color="#e66110"><b id="ipvjz">Skikda, the 04.11.2025</b></font></div></td></tr></tbody></table><div id="ihmt9" class="text-section"><div id="iiero" class="custom-text-block"></div><div id="ioml7" class="custom-text-block"></div><div id="innq2" class="custom-text-block"></div><div id="i5f5f" class="custom-text-block"></div><div class="custom-text-block" id="io1pm"></div><table id="idfkk"><tbody id="i5gsi"><tr id="iji5m"><td id="iirzp"><div class="custom-text-block" id="ipmha"><span id="icvk5"></span></div><div class="custom-text-block" id="i7hikr"></div><span id="idigv">                                        PRESCRIPTION<br/><br/></span><span id="i6fngl">Enter your text here...</span></td></tr></tbody></table> </div> <div class="custom-text-block" id="i8md1m"><span id="ixlzgj">Medication<br/><br/><br/><br/><br/><br/><br/><br/></span></div><table id="i7w93"><tbody><tr></tr></tbody></table><div id="iml6i" class="custom-footer"></div></body>`
      // );

      // editorInstance.setStyle(
      //   `* { box-sizing: border-box; } body {margin: 0;}*{box-sizing:border-box;}body{margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;}*{box-sizing:border-box;}body{margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;}#iw0e{height:150px;margin-top:0px;margin-right:auto;margin-bottom:10px;margin-left:auto;padding-top:5px;padding-right:5px;padding-bottom:5px;padding-left:5px;width:100%;}#i2pv2{padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;vertical-align:top;width:33.3333%;}#igc4j{padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;vertical-align:top;width:33.3333%;text-align:center;}#i6gbh{padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;vertical-align:top;width:33.3333%;text-align:center;}#iadqk{color:black;height:286px;width:261px;}#iy1kf{color:black;}.divider{background-color:rgba(0, 0, 0, 0.1);height:1px;}#i778m{width:100%;margin-top:10px;margin-bottom:10px;}#iumgo{height:150px;margin-top:0px;margin-right:auto;margin-bottom:10px;margin-left:auto;padding-top:5px;padding-right:5px;padding-bottom:5px;padding-left:5px;width:100%;}#ifrz5{padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;vertical-align:top;width:50%;}#ibfpj{padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;vertical-align:top;width:50%;}#ivyo7{padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;color:#e66110;font-weight:700;}#i4mle{padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;text-align:right;font-size:20px;}#ihmt9{font-size:18px;margin-bottom:20px;height:auto;min-height:250px;}#iml6i{position:fixed;bottom:0px;width:100%;font-size:18px;padding-top:20px;padding-right:20px;padding-bottom:20px;padding-left:20px;}#i7w93{height:150px;margin-top:0px;margin-right:auto;margin-bottom:10px;margin-left:auto;padding-top:5px;padding-right:5px;padding-bottom:5px;padding-left:5px;width:100%;}#iiero{font-size:18px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;}#ioml7{font-size:18px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;}#innq2{font-size:18px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;}#i5f5f{font-size:18px;margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;}#i8lzn{font-size:18px;margin:0;}#ika0j{font-weight:700;}#i2onl{font-size:18px;margin:0;}#ii8n3{font-size:18px;margin:0;}#iy9q8{font-size:18px;margin:0;}#i6uhf{font-size:18px;margin:0;}#iza8s{font-size:18px;margin:0;}#i9qol{font-size:18px;margin:0;}#idfkk{height:150px;margin:0 auto 10px auto;padding:5px 5px 5px 5px;width:100%;}#iirzp{padding:0;margin:0;vertical-align:top;color:#000000;}#ipmha{font-size:18px;margin:0;}#io1pm{font-size:18px;margin:0;}#idigv{font-size:42px;}#i7hikr{font-size:18px;margin:0;}#i8md1m{font-size:18px;margin:0;}#ixlzgj{color:#df0e0e;}`
      // );

      editorInstance.on("component:add", () => {
        if (isCancelled) return;
        const html = editorInstance.getHtml();
        const css = editorInstance.getCss();

        // Merge HTML and CSS
        // const mergedHtml = mergeHtmlWithInlineStyles(html, css);
        setHtmlContent(html);
        setCssContent(css);
      });

      editorInstance.on("component:update", () => {
        if (isCancelled) return;
        const html = editorInstance.getHtml();
        const css = editorInstance.getCss();

        // Merge HTML and CSS
        // const mergedHtml = mergeHtmlWithInlineStyles(html, css);
        setHtmlContent(html);
        setCssContent(css);
      });

      editorInstance.on("storage:load", () => {
        if (isCancelled) return;
        const html = editorInstance.getHtml();
        const css = editorInstance.getCss();

        // Merge HTML and CSS
        // const mergedHtml = mergeHtmlWithInlineStyles(html, css);
        setHtmlContent(html);
        setCssContent(css);
      });
      setEditorInstanceState(editorInstance);
    }

    return () => {
      isCancelled = true;
      if (editorInstance) {
        editorInstance.destroy();
      }
    };
  }, [isEditorVisible, editorContainer.current]);

  // Function to merge inline styles into the HTML content
  function mergeHtmlWithInlineStyles(html, css) {
    // Parse the CSS to get class/id-based styles
    const styleTags = parseCssToInline(css);

    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Loop through each element and apply inline styles
    const elements = tempDiv.querySelectorAll("*");

    elements.forEach(el => {
      const className = el.id;
      if (className && styleTags[className]) {
        el.style.cssText = styleTags[className];
      }
    });

    // Return the modified HTML
    return tempDiv.innerHTML;
  }

  // Function to parse the CSS rules and return inline styles
  function parseCssToInline(css) {
    const styleTags = {};
    const rules = css.split("}");

    rules.forEach(rule => {
      const parts = rule.split("{");
      if (parts.length === 2) {
        const selector = parts[0].trim();
        const declarations = parts[1].trim();

        // Handle both class and id selectors
        if (selector.startsWith(".")) {
          styleTags[selector.slice(1)] = declarations;
        } else if (selector.startsWith("#")) {
          styleTags[selector.slice(1)] = declarations;
        }
      }
    });

    return styleTags;
  }

  const captureTemplateImage = () => {
    return new Promise((resolve, reject) => {
      if (editorInstanceState) {
        // Find the container you want to capture (e.g., the full editor preview)
        const editorContainerEl = document.querySelector(".gjs-frame-wrapper");

        const iframe = editorContainerEl.querySelector("iframe");

        if (iframe && iframe.contentWindow) {
          // Only works if iframe is on the same domain
          html2canvas(iframe.contentWindow.document.body)
            .then(iframeCanvas => {
              // Use toBlob correctly by passing a callback function
              iframeCanvas.toBlob(blob => {
                if (blob) {
                  // Convert Blob to a File
                  const file = new File([blob], "template-image.png", {
                    type: "image/png", // MIME type
                    lastModified: Date.now(),
                  });

                  // Return the File through the Promise
                  resolve(file);
                } else {
                  reject("Failed to create Blob from canvas");
                }
              }, "image/png");
            })
            .catch(error => {
              reject("Error capturing iframe canvas: " + error);
            });
        } else {
          reject("Iframe or contentWindow is not available");
        }
      } else {
        reject("Editor instance is not available");
      }
    });
  };

  const handleSaveContent = async () => {
    if (!templateName) {
      toast.warning("Please enter template name.", {autoClose: 1500});
    } else if (!category) {
      toast.warning("Please select category.", {autoClose: 1500});
    } else {
      try {
        setBtnDis(true);
        let formData = new FormData();
        formData.append("user_id", "0");
        formData.append("template_name", templateName || "");
        
        // Ensure all components are rendered to HTML, including sections and divs
        const wrapper = editorInstanceState.getWrapper();
        const fullHtml = editorInstanceState.getHtml({
          attributes: true,
          components: true,
        });

        // Validation for QR code placeholder
        if (
          !fullHtml.includes("[code qr]") &&
          !fullHtml.includes("[qr code]") &&
          !fullHtml.includes("[qrcode]") &&
          !fullHtml.includes("[qr]")
        ) {
          toast.warning(
            "You forgot to add the QR code, please add it to save the template",
            { autoClose: 3000 }
          );
          setBtnDis(false);
          return;
        }

        formData.append("template_body", fullHtml);
        
        const editorCss = editorInstanceState.getCss({
          keepUnusedStyles: true
        }) || "";
        let finalStyle = editorCss.replace(/\[data-gjs-type="wrapper"\]/g, 'body');
        if (wrapper && wrapper.get('attributes').id) {
          finalStyle = finalStyle.replace(new RegExp('#' + wrapper.get('attributes').id, 'g'), 'body');
        }
        formData.append("style", finalStyle);
        
        // Append project data
        if (editorInstanceState && typeof editorInstanceState.getProjectData === 'function') {
          const projectData = editorInstanceState.getProjectData();
          formData.append("project_data", JSON.stringify(projectData));
        }
        formData.append("token", token);
        formData.append("category", category);

        // Extract font settings by reading computed styles from the GrapesJS iframe
        try {
          const DOCTOR_PLACEHOLDERS = [
            "[Détails du médecin]",
            "[Doctor Details]",
            "[détails du médecin]",
            "Détails du médecin",
            "Doctor Details",
          ];
          const PATIENT_PLACEHOLDERS = [
            "[Détails du patient]",
            "[Patient Details]",
            "[détails du patient]",
            "Détails du patient",
            "Patient Details",
          ];

          // Méthode 1 : computed styles depuis l'iframe GrapesJS (le plus fiable)
          const extractFromIframe = (placeholders) => {
            try {
              const frameWrapper = document.querySelector(".gjs-frame-wrapper");
              const iframe = frameWrapper
                ? frameWrapper.querySelector("iframe")
                : null;
              if (!iframe || !iframe.contentWindow) return null;
              const iDoc = iframe.contentWindow.document;
              const iWin = iframe.contentWindow;
              for (const el of iDoc.querySelectorAll("*")) {
                if (
                  placeholders.some((p) => (el.textContent || "").includes(p))
                ) {
                  let node = el;
                  for (let d = 0; d < 4; d++) {
                    if (!node || node === iDoc.body) break;
                    const cs = iWin.getComputedStyle(node);
                    const fontSize = cs.getPropertyValue("font-size") || "";
                    const fontFamily = cs.getPropertyValue("font-family") || "";
                    if (
                      fontSize &&
                      fontSize !== "16px" &&
                      fontSize !== "14px"
                    ) {
                      return {
                        fontSize: fontSize.trim() || null,
                        fontFamily: fontFamily.trim() || null,
                      };
                    }
                    node = node.parentElement;
                  }
                }
              }
            } catch (e) {}
            return null;
          };

          // Méthode 2 : HTML + CSS générés par GrapesJS (styles inline + classes)
          const extractFromGeneratedCss = (placeholders) => {
            try {
              const editorHtml = editorInstanceState.getHtml() || "";
              const editorCss = editorInstanceState.getCss() || "";
              const cssMap = {};
              const ruleRe = /\.([\w-]+)\s*\{([^}]*)\}/g;
              let rm;
              while ((rm = ruleRe.exec(editorCss)) !== null) {
                const cls = rm[1],
                  decls = rm[2];
                const fs = (decls.match(/font-size\s*:\s*([^;]+)/i) || [])[1];
                const ff = (decls.match(/font-family\s*:\s*([^;]+)/i) || [])[1];
                if (fs || ff)
                  cssMap[cls] = {
                    fontSize: (fs || "").trim() || null,
                    fontFamily: (ff || "").trim() || null,
                  };
              }
              const getFromEl = (el) => {
                const s = el.getAttribute("style") || "";
                const fs = (s.match(/font-size\s*:\s*([^;]+)/i) || [])[1];
                const ff = (s.match(/font-family\s*:\s*([^;]+)/i) || [])[1];
                if (fs || ff)
                  return {
                    fontSize: (fs || "").trim() || null,
                    fontFamily: (ff || "").trim() || null,
                  };
                for (const cls of Array.from(el.classList || [])) {
                  if (cssMap[cls]) return cssMap[cls];
                }
                return null;
              };
              const doc = new DOMParser().parseFromString(
                editorHtml,
                "text/html",
              );
              for (const el of doc.querySelectorAll("*")) {
                if (
                  placeholders.some((p) => (el.textContent || "").includes(p))
                ) {
                  let node = el;
                  for (let d = 0; d < 4; d++) {
                    if (!node) break;
                    const r = getFromEl(node);
                    if (r && (r.fontSize || r.fontFamily)) return r;
                    node = node.parentElement;
                  }
                }
              }
            } catch (e) {}
            return null;
          };

          // Méthode 3 : API GrapesJS getStyle() récursif
          const extractFromGjsApi = (placeholders) => {
            try {
              const walk = (comps) => {
                for (let i = 0; i < comps.length; i++) {
                  const c = comps.at(i);
                  let h = "";
                  try {
                    h = c.toHTML();
                  } catch (e) {}
                  if (
                    [c.get("content") || "", c.get("innerHTML") || "", h].some(
                      (s) => placeholders.some((p) => s.includes(p)),
                    )
                  ) {
                    let node = c;
                    for (let d = 0; d < 4; d++) {
                      if (!node) break;
                      const st = node.getStyle ? node.getStyle() || {} : {};
                      const fs = st["font-size"] || null;
                      const ff = st["font-family"] || null;
                      if (fs || ff) return { fontSize: fs, fontFamily: ff };
                      node = node.parent ? node.parent() : null;
                    }
                  }
                  const ch = c.components();
                  if (ch && ch.length) {
                    const r = walk(ch);
                    if (r) return r;
                  }
                }
                return null;
              };
              return walk(editorInstanceState.getWrapper().components());
            } catch (e) {}
            return null;
          };

          const resolveFont = (placeholders) =>
            extractFromIframe(placeholders) ||
            extractFromGeneratedCss(placeholders) ||
            extractFromGjsApi(placeholders) ||
            null;

          const doctorStyles = resolveFont(DOCTOR_PLACEHOLDERS);
          const patientStyles = resolveFont(PATIENT_PLACEHOLDERS);

          console.log("[FONT] doctor:", doctorStyles);
          console.log("[FONT] patient:", patientStyles);

          if (patientStyles?.fontFamily)
            formData.append("patient_font_family", patientStyles.fontFamily);
          if (patientStyles?.fontSize)
            formData.append("patient_font_size", patientStyles.fontSize);
          if (doctorStyles?.fontFamily)
            formData.append("doctor_font_family", doctorStyles.fontFamily);
          if (doctorStyles?.fontSize)
            formData.append("doctor_font_size", doctorStyles.fontSize);
        } catch (e) {
          console.error("Error extracting font styles:", e);
        }

        const templateBlob = await captureTemplateImage(); // Wait for the image to be captured
        formData.append("template_image", templateBlob);

        let response = await addDoctorTemplateApi(formData);
        if (response) {
          if (response.data.res === true) {
            toast.success(response.data.msg || "Saved successfully.", {autoClose: 1500});
            handleCancel();
            // setAllDetails(response.data);
            // setAppointments(response.data.appointments ?? []);
            // setFilteredAppointments(response.data.appointments ?? []);
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setBtnDis(false);
      }
    }
  };

  const handleChange = html => {
    editorContentRef.current = html;
  };

  const checkAdminToken = async () => {
    try {
      setScreenLoading(true);
      let formData = new FormData();
      formData.append("token", token);

      let response = await checkAdminTokenApi(formData);
      if (response) {
        if (response.data.res === true) {
          if (Array.isArray(response.data.data) && response.data.data.length > 0 && response.data.data[0].id) {
            // Proceed with your logic if the id exists
            setIsEditorVisible(true);
          } else {
            // Redirect to 404 if data is empty or doesn't have an id
            navigate("/404");
          }
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
    }
  };

  const handleCancel = () => {
    // Use the absolute URL for navigation
    window.location.href = `${ADMIN_DASHBOARD_URL}/doctor/template-list-admin`;
  };

  useEffect(() => {
    checkAdminToken();
  }, []);

  return (
    <div className="AdminPresManage">
      {screenLoading1 && <LoadingPage />}
      {screenLoading ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="hdnDiv nurseTop">
            <h2>
              <span>
                <img src={icon1} alt="Configuration icon" />
                {templateName
                  ? templateName
                  : category === "1"
                    ? ""
                    : "Ajouter un modèle d'ordonnance"}
              </span>
              <div className="btnSection">
                <input
                  type="text"
                  placeholder="Entrer le nom du modèle"
                  className="FormControl SelectForm"
                  value={templateName}
                  onChange={(e) => setTemplateName(e.target.value)}
                />
                <select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  className="FormControl SelectForm"
                >
                  <option value="" selected hidden>
                    Choisir une catégorie
                  </option>
                  <option value="1">Ordonnance</option>
                  <option value="2">Document</option>
                </select>

                <button
                  className="saveBtn"
                  onClick={handleSaveContent}
                  disabled={btnDis}
                >
                  {btnDis ? "Veuillez patienter..." : "Enregistrer"}
                </button>
                <button className="cancelBtn" onClick={handleCancel}>
                  Annuler
                </button>
              </div>
            </h2>
          </div>
          <div style={{display: "flex"}}>
            {/* Blocks Container */}
            <div
              id="blocks"
              style={{
                width: "300px",
                borderRight: "1px solid #ddd",
                height: "100vh",
                overflow: "auto",
              }}></div>

            {/* GrapesJS Editor Container */}
            <div className="grapesEditorContainer" ref={editorContainer} id="gjsAdmin" style={{height: "100vh", width: "100%"}} />
            {/* <button>Get html and css</button> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPrescriptionManagement;
